<template>
    <v-row>
        <v-col cols="12" :align="align">
            <v-btn
                class="normal-btn"
                text :color="color"
                @click="goTo"
            >
                {{ name }}
                <v-icon right>$right_arrow</v-icon>
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "goTo",
    props: {
        name: {
            type: String,
            default: '',
        },
        to: {
            type: Object,
            default: null,
        },
        color: {
            type: String,
            default: 'accent',
        },
        align: {
            type: String,
            default: 'right',
        }
    },
    methods: {
        goTo() {
            const vm = this
            vm.$router.push(vm.to)
        }
    }
}
</script>

<style scoped>

</style>